export const goBack = (navigate) => {
  if (window.history?.length && window.history.length > 1) {
    navigate(-1);
  } else {
    navigate("/", { replace: true });
  }
}